import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { BookOpen, CheckCircle2, FileText, LineChart } from 'lucide-react';
export function ChapterList() {
  const chapters = ['Capítulo 1: Por qué la IA es tu nuevo empleado estrella.', 'Capítulo 2: Identificación de procesos automatizables en tu negocio.', 'Capítulo 3: Herramientas de IA simples que puedes usar hoy.', 'Capítulo 4: Guía paso a paso para implementar tu primera automatización en 48 horas.', 'Capítulo 5: Cómo monitorear y ajustar tus automatizaciones.'];
  const bonuses = [{
    icon: CheckCircle2,
    text: 'Checklists accionables en cada capítulo.'
  }, {
    icon: FileText,
    text: 'Hojas de trabajo: Plantillas para implementar en tu negocio de inmediato.'
  }, {
    icon: LineChart,
    text: 'Un caso de estudio real de automatización exitosa.'
  }];
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5
      }
    }
  };
  return <section className="py-24 bg-[#141414] border-y border-white/5" data-id="element-26">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-27">
        <div className="text-center mb-16" data-id="element-28">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-29">
            Lo que obtienes
          </h2>
          <p className="text-xl text-gray-400" data-id="element-30">
            Todo lo que necesitas para empezar hoy mismo
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12" data-id="element-31">
          <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
          once: true
        }} className="lg:col-span-7 space-y-4" data-id="element-32">
            <h3 className="text-2xl font-semibold text-white mb-6 flex items-center gap-3" data-id="element-33">
              <BookOpen className="text-amber-500 w-6 h-6" data-id="element-34" />
              Contenido del eBook
            </h3>
            {chapters.map((chapter, index) => <motion.div key={index} variants={itemVariants} className="p-6 rounded-xl bg-[#1A1A1A] border border-white/5 hover:border-amber-500/30 transition-colors" data-id="element-35">
                <p className="text-lg text-gray-300" data-id="element-36">{chapter}</p>
              </motion.div>)}
          </motion.div>

          <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
          once: true
        }} className="lg:col-span-5 space-y-4" data-id="element-37">
            <h3 className="text-2xl font-semibold text-white mb-6 flex items-center gap-3" data-id="element-38">
              <Zap className="text-amber-500 w-6 h-6" data-id="element-39" />
              Materiales Extra
            </h3>
            {bonuses.map((bonus, index) => {
            const Icon = bonus.icon;
            return <motion.div key={index} variants={itemVariants} className="flex items-start gap-4 p-6 rounded-xl bg-gradient-to-br from-amber-500/10 to-transparent border border-amber-500/20" data-id="element-40">
                  <Icon className="w-6 h-6 text-amber-500 flex-shrink-0 mt-1" data-id="element-41" />
                  <p className="text-lg text-gray-200" data-id="element-42">{bonus.text}</p>
                </motion.div>;
          })}
          </motion.div>
        </div>
      </div>
    </section>;
}
// Re-import Zap for the bonus section header
import { Zap } from 'lucide-react';